import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { appPageRootStyles } from "../appBar/appBarTheme";
import { recordBatchInHistory } from "./widgets/utils";
import {
  WelcomeWidget,
  ResumeBatchWidget,
  ActiveBatchesWidget,
  RecentProjectsWidget,
  QuickActionsWidget,
  AssignedBatchesWidget,
} from "./widgets";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...appPageRootStyles(theme),
      minHeight: `calc(100vh - ${theme.spacing.unit * 2}px)`,
      paddingBottom: theme.spacing.unit * 4,
      maxWidth: 1100,
      margin: "0 auto",
    },
    topRow: {
      display: "flex",
      flexDirection: "row",
      gap: `${theme.spacing.unit * 2}px`,
      marginBottom: theme.spacing.unit * 4,
      alignItems: "stretch",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
  });

interface PropsType {
  classes: any;
  user: any;
  isAdmin: boolean;
  roleLabel: string;
}

const Homepage = (props: PropsType) => {
  const { classes, user, isAdmin, roleLabel } = props;

  const [resumeRefreshKey, setResumeRefreshKey] = useState(0);

  const handleBatchNavigate = (batchId: number) => {
    recordBatchInHistory(batchId, user.id);
    setResumeRefreshKey((key) => key + 1);
  };

  return (
    <div
      className={classes.root}
      style={isAdmin ? { maxWidth: 1400 } : undefined}
    >
      <Helmet>
        <title>Accueil</title>
      </Helmet>

      <WelcomeWidget firstName={user.firstName} roleLabel={roleLabel} />

      <div className={classes.topRow}>
        <ResumeBatchWidget
          resumeRefreshKey={resumeRefreshKey}
          onBatchNavigate={handleBatchNavigate}
        />
        <ActiveBatchesWidget
          isAdmin={isAdmin}
          onBatchNavigate={handleBatchNavigate}
        />
        <RecentProjectsWidget isAdmin={isAdmin} />
      </div>

      <QuickActionsWidget isAdmin={isAdmin} />

      <AssignedBatchesWidget
        isAdmin={isAdmin}
        onBatchNavigate={handleBatchNavigate}
      />
    </div>
  );
};

export default withStyles(styles)(Homepage);
